import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Typography,
  Button,
} from '@material-ui/core';
import Title from './Title';
import { Redirect } from 'react-router-dom';
import { validarSoloUnPermiso } from '../../../../../helpers/permisos';
import { MEDICACION_MENU_PERMISOS } from '../../../../../utils/permisos';
import {
  AREAS_USUARIOS,
  STEPPER_MEDICACION,
} from '../../../../../utils/constants';
import {
  clearReducer,
  getMedicacionEmpadronamientosActivosHistorialPrevio,
  getMedicacionHistorialPrevio,
  setActiveStep,
  setAfiliadoSeleccionado,
} from '../../../../../actions/empadronamiento/Empadronamiento';
import { MedicacionHistorialItem } from '../../../../empadronamiento/IngresoMedicacion/MedicacionHistorialItem';
import { useState } from 'react';

export const CardMedicacion = (props) => {
  const dispatch = useDispatch();
  const { hce, dataAfiliado, disabled } = props;
  const [redirect, setRedirect] = useState(false);
  const { solicitudes } = useSelector((state) => state.empadronamiento);
  const { permisos: permisosUser, areas } = useSelector((state) => state.auth);

  useEffect(() => {
    if (hce?.idAfiliado) {
      dispatch(
        getMedicacionEmpadronamientosActivosHistorialPrevio(hce.idAfiliado),
      );
      dispatch(getMedicacionHistorialPrevio(hce.idAfiliado));
      dispatch(clearReducer());
    }

  }, [dispatch]);

  return (
    <React.Fragment>
      <Title>
        Medicación Activa{' '}
        {validarSoloUnPermiso(
          permisosUser,
          MEDICACION_MENU_PERMISOS.INGRESO_SOLICITUD,
        ) &&
          areas.filter((area) => area.idArea === AREAS_USUARIOS.CENTROS_MEDICOS)
            .length > 0 && (
            <>
              {!disabled &&
                <Button
                  disabled={disabled}
                  variant="contained"
                  color="primary"
                  size="small"
                  onClick={() => {
                    dispatch(setAfiliadoSeleccionado(dataAfiliado));
                    dispatch(setActiveStep(STEPPER_MEDICACION.DATOS_TITULAR));
                    setRedirect(true);
                  }}
                >
                  + Ingresar Medicacion
                </Button>
              }
            </>
          )}
      </Title>
      {redirect && (
        <Redirect
          to={{
            pathname: '/medicacion',
            state: {
              from: '/medicacion/gestion',
            },
          }}
        />
      )}
      {Array.isArray(solicitudes) && solicitudes?.length > 0 ? (
        <Table>
          <TableHead>
            <TableRow>
              <TableCell style={{ width: '8%' }}>Estado</TableCell>
              <TableCell style={{ width: "6%" }}>Empadronamiento N°</TableCell>
              <TableCell style={{ width: '6%' }}>Solicitud</TableCell>
              <TableCell style={{ width: '10%' }}>Inicio</TableCell>
              <TableCell style={{ width: '10%' }}>Fin</TableCell>
              <TableCell style={{ width: '20%' }}>Programa</TableCell>
              <TableCell style={{ width: '12%' }}>Usuario</TableCell>
              <TableCell style={{ width: '5%' }}>Medicamentos</TableCell>
              <TableCell style={{ width: '5%' }}>Diagnósticos</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {solicitudes.map((solicitud, index) => {
              return (
                <MedicacionHistorialItem
                  key={solicitud?.idSolicitud.toString()}
                  solicitud={solicitud}
                />
              );
            })}
          </TableBody>
        </Table>
      ) : (
        <Typography style={{ fontSize: '1.1rem', fontStyle: 'italic' }}>
          No hay solicitud de medicaciones
        </Typography>
      )}
    </React.Fragment>
  );
};
